import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { companyService } from '../../services/api';

export const getCompanies = createAsyncThunk(
  'companies/getCompanies',
  async (_, { rejectWithValue }) => {
    try {
      const response = await companyService.getCompanies();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getMyCompanies = createAsyncThunk(
  'companies/getMyCompanies',
  async (_, { rejectWithValue }) => {
    try {
      const response = await companyService.getMyCompanies();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCompany = createAsyncThunk(
  'companies/createCompany',
  async (companyData, { rejectWithValue }) => {
    try {
      const response = await companyService.createCompany(companyData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateCompany = createAsyncThunk(
  'companies/updateCompany',
  async ({ id, companyData }, { rejectWithValue }) => {
    try {
      const response = await companyService.updateCompany(id, companyData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCompany = createAsyncThunk(
  'companies/deleteCompany',
  async (id, { rejectWithValue }) => {
    try {
      await companyService.deleteCompany(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  companies: [],
  myCompanies: [],
  loading: false,
  error: null,
};

const companySlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Companies
      .addCase(getCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload;
      })
      .addCase(getCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // Get My Companies
      .addCase(getMyCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMyCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.myCompanies = action.payload;
      })
      .addCase(getMyCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // Create Company
      .addCase(createCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companies.push(action.payload);
        state.myCompanies.push(action.payload);
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // Update Company
      .addCase(updateCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.companies.findIndex(company => company.id === action.payload.id);
        if (index !== -1) {
          state.companies[index] = action.payload;
        }
        const myIndex = state.myCompanies.findIndex(company => company.id === action.payload.id);
        if (myIndex !== -1) {
          state.myCompanies[myIndex] = action.payload;
        }
      })
      .addCase(updateCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      })
      // Delete Company
      .addCase(deleteCompany.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = state.companies.filter(company => company.id !== action.payload);
        state.myCompanies = state.myCompanies.filter(company => company.id !== action.payload);
      })
      .addCase(deleteCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export const { clearError } = companySlice.actions;
export default companySlice.reducer;
